import { Box } from "@procore/core-react";

import { DebugUtilsToolbar, DetailsToolbar } from "components/toolbars";
import { useNonMarkerUIIsHidden } from "features/markers/markerCreationUtils";
import { isNovolibDebug } from "utils/novolibDebug";

import { useDetailsToolbarRegistration } from "./useDetailsToolbarRegistration";

export function DetailsMenu() {
    const shouldHideUI = useNonMarkerUIIsHidden();
    const showDebugUtils = isNovolibDebug();

    useDetailsToolbarRegistration();

    return (
        <Box
            style={{
                position: "absolute",
                top: 8,
                left: 8,
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "flex-start",
                gap: 8,
            }}
        >
            <Box
                style={{
                    visibility: shouldHideUI ? "hidden" : undefined,
                    pointerEvents: shouldHideUI ? "none" : undefined,
                }}
            >
                <DetailsToolbar>{showDebugUtils && <DebugUtilsToolbar />}</DetailsToolbar>
            </Box>
        </Box>
    );
}
